import React, { useEffect, useRef, useState, version } from "react";
import copyIcon from "../../assets/copy.svg";
import exportIcon from "../../assets/export.svg";
import backlogIcon from "../../assets/backlog.svg";
import archiveIcon from "../../assets/archive.svg";
import "./SharePopup.css";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import { useDispatch } from "react-redux";
import {
  deleteVersion,
  updateVersionArchiveStatus,
  updateVersionNote,
} from "../../store/projectsSlice";
import { useNavigate } from "react-router";
import { generateShareLink } from "../../store/usersSlice";
import toast from "react-hot-toast";

const ACCESS_OPTIONS = [
  { value: "VIEWER", label: "для просмотра" },
  { value: "COMMENTER", label: "для комментирования" },
  { value: "EDITOR", label: "для редактирования" },
];

const SharePopup = ({
  video,
  onClose,
  onOpenBacklog,
  updateVideo = () => {},
  className = "",
}) => {
  const [access, setAccess] = useState("VIEWER");
  const popupRef = useRef();
  const [comment, setComment] = useState(video.releaseNotes || "");
  const [emailValue, setEmailValue] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [copied, setCopied] = useState(false);
  // const shareLink = `https://www.figma.com/design/${video?.id || ""}`;
  const [shareLink, setShareLink] = useState("");
  const [linkLoading, setLinkLoading] = useState(true);
  const [isSaved, setIsSaved] = useState(false);
  let updateCommentTimeout = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        event.target.className !== "video-page-header-title" &&
        event.target.className !== "video-page-header-img" &&
        event.target.className !== "video-share-button-block" &&
        event.target.className !== "video-page-share-label-text"
      ) {
        onClose();
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  useEffect(() => {
    setLinkLoading(true);
    let values = {
      resourceId: video.id,
      resourceType: "VIDEO",
      role: access,
    };
    if (access === "EDITOR") {
      values = {
        ...values,
        email: emailValue,
      };
      setEmailValue("");
    }
    if (access !== "EDITOR")
      dispatch(generateShareLink(values)).then((res) => {
        setLinkLoading(false);
        if (!res.error) {
          setShareLink(res.payload);
        }
      });
  }, [access]);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  const archiveVersion = () => {
    if (confirm("Вы действительно хотите отправить версию в архив?")) {
      dispatch(
        updateVersionArchiveStatus({ versionId: video.id, isArchived: true })
      ).then((res) => {
        if (!res.error) {
          toast.success("Версия перемещена в архив");
          navigate(-1);
        }
      });
    }
  };

  const handleChangeComment = (value) => {
    setIsSaved(false);
    setComment(value);
    clearTimeout(updateCommentTimeout.current);
    updateCommentTimeout.current = setTimeout(() => {
      dispatch(
        updateVersionNote({ versionId: video.id, releaseNote: value })
      ).then((res) => {
        if (!res.error) {
          updateVideo();
          setIsSaved(true);
        }
      });
    }, 1000);
  };

  const validateEmail = (email) => {
    return email.match("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$");
  };

  const handleChangeEmailValue = (value) => {
    setIsSaved(false);
    if (shareLink) {
      setShareLink("");
    }
    setEmailValue(value.trim());
    clearTimeout(updateCommentTimeout.current);
    if (validateEmail(value)) {
      updateCommentTimeout.current = setTimeout(() => {
        dispatch(
          generateShareLink({
            resourceId: video.id,
            resourceType: "VIDEO",
            role: access,
            email: value,
          })
        ).then((res) => {
          if (!res.error) {
            setShareLink(res.payload);
          }
        });
        setIsSaved(true);
      }, 1000);
    }
  };

  const handleInviteSharedUser = () => {
    dispatch(
      generateShareLink({
        resourceId: video.id,
        resourceType: "VIDEO",
        role: access,
        email: emailValue,
      })
    ).then((res) => {
      if (!res.error) {
        setShareLink(res.payload);
        navigator.clipboard.writeText(res.payload);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    });
  };

  return (
    <div ref={popupRef} className={`share-popup-context-menu ${className}`}>
      <div className="share-popup-row share-popup-link-row">
        <span className="share-popup-label">Поделиться ссылкой</span>
        <div className="share-popup-access-select">
          <select value={access} onChange={(e) => setAccess(e.target.value)}>
            {ACCESS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {access !== "EDITOR" && (
        <div className="share-popup-row">
          <input
            className="share-popup-link-input"
            value={linkLoading ? "..." : shareLink}
            readOnly
            placeholder={isSaved ? "Загрузка..." : "..."}
          />
          <button className="share-popup-copy-btn" onClick={handleCopy}>
            <img src={copyIcon} alt="copy" style={{ width: 18, height: 18 }} />
          </button>
          {/* {copied && (
            <span className="share-popup-copied">{t("video.copied")}</span>
          )} */}
        </div>
      )}
      {copied && access !== "EDITOR" && (
        <span className="project-share-popup-copied">
          {"Ссылка скопирована в буфер!"}
        </span>
      )}

      {access === "EDITOR" && (
        <span
          style={{
            display: "block",
            textAlign: "left",
            color: "#6e7986",
            fontSize: 14,
            lineHeight: 1,
            marginBottom: 16,
          }}
        >
          Введите почту пользователя, чтобы расшарить видео с возможностью
          редактирования
        </span>
      )}
      {access === "EDITOR" && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            marginBottom: 12,
          }}
        >
          <input
            className="share-popup-email"
            placeholder="Электронная почта"
            value={emailValue}
            style={{
              marginBottom: 0,
              minHeight: 18,
              background: "#152c4e",
              borderColor: "#4056d0",
            }}
            onChange={(e) => {
              handleChangeEmailValue(e.target.value);
            }}
          />
          <PrimaryButton
            onClick={() => {
              handleInviteSharedUser();
            }}
            isLoading={false}
            text={"Пригласить"}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              borderRadius: 8,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      )}
      {copied && access === "EDITOR" && (
        <span className="project-share-popup-copied">
          {"Ссылка скопирована в буфер!"}
        </span>
      )}
      <textarea
        className="share-popup-comment"
        placeholder={"Комментарий к видео (доступен всем по ссылке)"}
        value={comment}
        onChange={(e) => {
          handleChangeComment(e.target.value);
        }}
      />

      {/* {isSaved && (
        <span className="share-popup-changes-saved">Изменения сохранены</span>
      )} */}
      <div className="share-popup-actions">
        {/* <button
          className="share-popup-action"
          onClick={() => alert("Экспорт видео")}
        >
          <img src={exportIcon} alt="export" /> {t("video.exportVideo")}
        </button> */}
        {/* <button
          className="share-popup-action"
          onClick={() => {
            if (onClose) onClose();
            if (onOpenBacklog) onOpenBacklog();
          }}
        >
          <img src={backlogIcon} alt="backlog" /> {t("video.versionBacklog")}
        </button> */}
        <button className="share-popup-action" onClick={() => archiveVersion()}>
          <img src={archiveIcon} alt="archive" /> {t("video.sendToArchive")}
        </button>
      </div>
    </div>
  );
};

export default SharePopup;
